import { Component }                      from '@angular/core';
import { ViewChild, OnInit, OnDestroy }   from '@angular/core';
import { NavController, ViewController }  from 'ionic-angular';
import { NavParams }                      from 'ionic-angular';
import { Content }                        from 'ionic-angular';

import helper                             from "../../helper";
import { Book }                           from "../../models/book";
import { BookService }                    from "../../services/book.service";
import { MiscService }                    from "../../services/misc.service";
import { DraInfiniteSwipeDirective }      from "../../directives/dra-infinite-swipe.directive";
import { ReaderInnerComponent }           from "./reader-inner.component";

@Component({
  selector: 'dra-reader',
  templateUrl: 'reader.component.html',
  // styleUrls: ['reader.component.scss']
})
export class ReaderComponent implements OnInit, OnDestroy {
  public innerPage = ReaderInnerComponent;
  @ViewChild('readerContainer') content: Content;
  @ViewChild(DraInfiniteSwipeDirective) swiper: DraInfiniteSwipeDirective;
  private book: Book;
  private bookAlias: string;
  private chapterAlias: string;
  private loggedIn: boolean = true;
  private swiperOptions;

  public constructor(
    private viewController: ViewController,
    private navController: NavController,
    private navParams: NavParams,
    private bookService: BookService,
    private miscService: MiscService
  ) {
  }

  public async ngOnInit() {
    try {
      this.bookAlias = this.navParams.get('bookAlias');
      this.chapterAlias = this.navParams.get('chapterAlias');
      let previousView = this.navController.getPrevious();
      if (previousView && previousView.id == 'Book') previousView.data = {bookAlias: this.bookAlias};
      // debugger;

      // this.userService.getUser();
      this.init();

      // console.log(this.navController._views);

    } catch (error) {
      console.log(error);
    }
  }
  public ngOnDestroy() {
    this.bookService.stopPreloadChapters();
  }
  public close() {
    this.miscService.changeUrl(`books/${this.bookAlias}`, {}, false);
    this.viewController.dismiss();
  }
  public async init(): Promise<void> {
    let book: Book;
    this.miscService.startLoading();
    try {
      book = this.book = await this.bookService.getBook(this.bookAlias, {reload: true}, true);
      
    } catch (error) {
      this.miscService.stopLoading();
      return;
    }

    this.miscService.stopLoading();
    this.miscService.setTitle(book.name);

    if (!this.chapterAlias) {
        let chapter = (await this.bookService.getRecent(this.book)) || this.book.chapters[0];
        // if (!chapter) chapter = this.book.chapters[0];

        this.chapterAlias = chapter.alias;
    }
    let currentIndex = helper.findIndex(book.chapters, this.chapterAlias, 'alias');
    if (currentIndex < 0) currentIndex = 0;

    await this.bookService.preloadChapters(book.alias, currentIndex, 3);

    this.swiperOptions = {
      total: book.chapters.length,
      startIndex: currentIndex,
      currentIndex: currentIndex,
      getItem: (index, crawl) => this.getChapter(book, index, crawl),
      onChange: index => this.onChapterChange(book, index),
    };
  }
  public async getChapter(book, index, crawl): Promise<any> {
    let chapter = book.chapters[index];
    if (!chapter) throw {message: 'Chapter not available'};

    try {
      if (index == this.swiperOptions.currentIndex) this.miscService.startLoading();

      let _chapter = await this.bookService.getChapter(book.alias, chapter.alias, {crawl: crawl});

      if (index == this.swiperOptions.currentIndex) this.miscService.stopLoading();

      return _chapter;
    } catch (error) {
      if (index == this.swiperOptions.currentIndex) this.miscService.stopLoading();

      throw error;
      // return
    }
  }
  public goChapter(index): void {
    this.swiper && this.swiper.goTo(index);
  }
  public prevChapter(): void {
    this.swiper && this.swiper.prev();
  }
  public nextChapter(): void {
    this.swiper && this.swiper.next();
  }
  public reloadChapter() {
    this.swiper && this.swiper.reloadCurrent();
  }

  private async onChapterChange(book: Book, chapterIndex: number): Promise<void> {
    let item = book.chapters[chapterIndex];

    this.chapterAlias = item.alias;
    // this.miscService.changeUrl(`books/${book.alias}/${item.alias}`, {}, false);
    this.miscService.setTitle(`${book.name} - ${item.name}`);

    if (this.content) this.content.scrollTo(0, 0);

    try {
      // console.log(this.navController._views);
      if (this.loggedIn) {
        await this.bookService.read(book, item);
      }
    } catch (error) {
      console.log(error);
    }

    this.bookService.preloadChapters(book.alias, chapterIndex);
  }
}



// WEBPACK FOOTER //
// ./src/components/reader/reader.component.ts